import { render, staticRenderFns } from "./card-share-detail.vue?vue&type=template&id=2226c7c2&scoped=true&"
import script from "./card-share-detail.vue?vue&type=script&lang=js&"
export * from "./card-share-detail.vue?vue&type=script&lang=js&"
import style0 from "./card-share-detail.vue?vue&type=style&index=0&id=2226c7c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2226c7c2",
  null
  
)

export default component.exports